import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/payment-plans/payment-methods/:paymentMethodId']['GET'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getPaymentPlansByPaymentMethodId = async ({ paymentMethodId }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/payment-plans/payment-methods/${paymentMethodId}`);
  return response.data;
};

export default getPaymentPlansByPaymentMethodId;
